import { render, staticRenderFns } from "./SolicitudEventoDetalle.vue?vue&type=template&id=30d5cf08"
import script from "./SolicitudEventoDetalle.vue?vue&type=script&lang=js"
export * from "./SolicitudEventoDetalle.vue?vue&type=script&lang=js"
import style0 from "./SolicitudEventoDetalle.vue?vue&type=style&index=0&id=30d5cf08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports